export default {
  confirmOrder: "Conferma l'ordine",
  createSuccess: 'Ordine creato con successo',
  orderPrice: "Prezzo totale dell'ordine",
  otherAction: 'Altre azioni',
  orderStatus: "Stato dell'ordine",
  afterSales: 'Post-vendita',
  allSelect: 'Seleziona tutto',
  orderNo: 'N. ordine',
  createTime: 'Ora di creazione',
  productRemark: 'Informazioni sulla nota del prodotto',
  productRemarkHolder:
    "Messaggio per l'agente d'acquisto, se non ci sono requisiti di acquisto speciali, non compilare.",
  orderDetail: "Dettagli dell'ordine",
  goPay: 'Paga',
  cancelpay: 'Annulla il pagamento',
  cancelPay: 'Annullare il pagamento?',
  cancelOrder: "Annullare l'ordine?",
  cancelorder: "Annulla l'ordine",
  cancelOrderProduct: 'Annullare il prodotto?',
  cancelorderProduct: 'Annulla il prodotto',
  cancelPayResultHint:
    "Dopo l'annullamento, il pagamento non potrà essere ripristinato, seleziona il motivo dell'annullamento del pagamento",
  cancelOrderResultHint:
    "Dopo l'annullamento, l'ordine non potrà essere ripristinato, indica il motivo dell'annullamento dell'ordine",
  delOrder: "Elimina l'ordine",
  delOrderHint:
    "Sei sicuro di voler eliminare l'ordine? Se il prodotto è stato rimborsato, l'articolo non verrà restituito al venditore per un rimborso",
  cancelSuccess: 'Annullamento riuscito',
  delSuccess: 'Eliminazione riuscita',
  orderBin: 'Cestino degli ordini',
  backOrder: 'Torna al mio ordine',
  restoreOrder: "Ripristina l'ordine",
  remark: 'Note',
  all: 'Tutti',
  productName: 'Nome del prodotto',
  submitTime: 'Ora di invio',
  orderConsult: "Richiesta d'ordine",
  appendService: 'Servizio aggiuntivo',
  iKnow: 'Ho capito',
  cancelReturnBag: 'Annulla il reso e il cambio',
  isCancelApply: 'Sei sicuro di voler annullare la richiesta?',
  cancelBackTax: "Annulla l'integrazione del pagamento",
  productAttr: 'Attributi del prodotto',
  backTaxType: 'Tipo di integrazione del pagamento',
  taxPrice: "Prezzo dell'integrazione del pagamento",
  productBackTax: 'Integrazione del pagamento del prodotto',
  freightBackTax: 'Integrazione del pagamento del trasporto',
  productTaxPrice: "Prezzo dell'integrazione del pagamento del prodotto",
  freightTaxPrice: "Prezzo dell'integrazione del pagamento del trasporto",
  totalTaxPrice: "Prezzo totale dell'integrazione del pagamento",
  productStatus: 'Stato del prodotto',
  isNeedTax: "Richiede un'integrazione del pagamento",
  yes: 'Sì',
  no: 'No',
  iThinkAbout: 'Ci penserò',
  revokeCheckedProduct: 'Revoca il prodotto selezionato',
  taxTips1:
    "Si prega di [Effettuare l'integrazione del pagamento] o [Annullare] il prima possibile per non compromettere l'acquisto di altri prodotti nell'ordine.",
  cancelTaxTips1:
    "Se non desideri effettuare l'integrazione del pagamento, non potremo acquistare il prodotto che la richiede.",
  cancelTaxTips2:
    'I prodotti contrassegnati verranno annullati dopo la revoca e il costo del prodotto verrà rimborsato sul tuo account.',
  cancelTaxTips3:
    'I prodotti non contrassegnati continueranno a essere conservati e continueremo ad acquistare per te.',
  cancelReason: {
    0: 'Non voglio acquistarlo',
    1: 'Informazioni inserite in modo errato',
    2: 'Venditore esaurito',
    3: 'Impossibile pagare',
    4: 'Altre ragioni',
    5: 'Rischio del marchio',
  },
  hint: 'Indizio',
  orderStatusEnum: {
    0: 'In attesa di pagamento',
    1: 'Non elaborato',
    2: 'In fase di revisione',
    3: 'Ordine trasferito',
    4: 'Ordine annullato',
    5: 'Integrazione del pagamento del trasporto',
    6: 'Revisione del controllo dei rischi',
    7: 'Ordine revocato',
    8: 'Pagamento in corso',
    9: 'Completato',
  },
  returnGood: {
    name: 'Reso/Cambio',
    selectType: 'Seleziona il tipo',
    returnGood: 'Reso',
    returnDayTips: 'Generalmente richiede 7-15 giorni',
    changeGood: 'Cambio',
    changeDayTips: 'Generalmente richiede 7-20 giorni',
    returnReasonEnum: {
      0: 'Acquistato per errore/Non mi piace',
      1: 'Il venditore ha inviato il prodotto sbagliato?',
      2: 'Problema di qualità del prodotto',
      3: 'Non spedito entro il tempo concordato',
      5: 'Altre ragioni',
    },
    returnReasonSelect: 'Seleziona il motivo del reso',
    returnExplain: 'Istruzioni per il reso',
    residueReturnNumTips: 'Diritti di reso del servizio gratuiti rimanenti questo mese',
    returnTips:
      'Verifica finale del reso dovuta al venditore o alla piattaforma, acbuy rimborserà le spese di spedizione che hai sostenuto.',
    changeTips:
      'Per resi o cambi dovuti a motivi imputabili al venditore, potresti dover comunque sostenere una parte delle spese di spedizione del cambio.',
    returnTip4: 'Promemoria amichevole',
    returnTip5:
      "Il servizio di reso e cambio fisserà un certo numero di operazioni di servizio gratuite. (Ogni utente può richiedere il reso o il cambio della merce senza costi di servizio operativo per la prima volta ogni mese, mentre le spese di spedizione generate dal reso o dal cambio della merce vengono negoziate tra l'agente e il venditore e riscosse da acbuy.) Costo del servizio di reso e cambio acbuy: 5 Yuan/ordine",
    returnTip10:
      "Se il reso o il cambio è dovuto a responsabilità dell'agente d'acquisto, del venditore o della piattaforma, il sistema rimborserà questi 5 Yuan di costi operativi sul tuo conto del saldo acbuy.",
  },
  holder: {
    selectCancelReason: "Seleziona il motivo dell'annullamento",
    inputOtherReason: 'Inserisci il motivo',
    inputSearchHint: 'Nome/N. ordine/N. prodotto',
    inputCancelReason: "Inserisci il motivo dell'annullamento dell'ordine",
  },
  selectProducts: 'Seleziona i prodotti',
  confirmStepOrder: "Conferma l'ordine",
  PayForProducts: 'Paga i prodotti',
  sendingPackages: 'Invio dei pacchi',
  submitDelivery: 'Invia per la consegna',
  readAgreeText: 'Ho letto e accetto',
  disclaimer: 'Esclusione di responsabilità',
  orderNote:
    "Nota: Dopo aver effettuato il pagamento, dovrai inviare il pacco per la spedizione internazionale una volta che l'ordine arriva e viene immagazzinato nel magazzino.",
  goPay2: 'Pagamento aggiuntivo',
  backTax: "Effettua l'integrazione del pagamento",
  reminder: 'Promemoria',
  disclaimer1: 'Descrizione degli articoli proibiti',
  disclaimer2: 'Termini di utilizzo',
  disclaimer3: 'Politica di reso',
  customPhotosTips:
    'Una fotografia fornisce solo un requisito di dettaglio per fotografare un articolo',
  backCartEdit: 'Torna alla modifica del carrello',
  customPhotosReminderLabel: 'Promemoria amichevole',
  customPhotosReminder:
    'Una foto fornisce solo un requisito di dettaglio per scattare una foto di un singolo prodotto',
  packageAgreeTip1:
    '1. Ritardi, danni, perdite, tasse, confische e altre incertezze relative ai servizi del fornitore di logistica sono al di fuori del nostro controllo e non saremo ritenuti responsabili per gli obblighi derivanti. Tuttavia, faremo del nostro meglio per ricordarti di riflettere attentamente prima di effettuare un acquisto, aiutarti a risolvere eventuali problemi con il fornitore di logistica e risarcirti in conformità con la politica post-vendita fornita dal fornitore di logistica.',
  packageAgreeTip2:
    '2. Ti consigliamo di dichiarare accuratamente il tuo pacco. Se il tuo pacco è soggetto a controlli casuali durante lo sdoganamento nel paese di destinazione, potresti dover pagare delle tasse. Se ricevi una notifica di tassazione, ti preghiamo di pagare le tasse di conseguenza, altrimenti potresti affrontare conseguenze come il pagamento di elevate spese di reso e la distruzione del pacco.',
  applyRefund: 'Richiedi un rimborso',
  refundReminder:
    "Suggerimenti: Dopo aver richiesto un rimborso, l'acquirente verificherà lo stato del prodotto e non potrà annullare la richiesta di rimborso prima di averlo verificato.",
  inputApplyReason: 'Inserisci il motivo della richiesta',
  orderConfirm: "Conferma dell'ordine",
  replyMsg: 'Messaggio di risposta',
  replyMsgTips:
    "Prendi nota delle informazioni che invii, le notificheremo all'acquirente per la verifica.",
  shoppingOrder: "Ordini dell'agente d'acquisto",
  transportOrder: 'Ordini di trasferimento pacchi',
  choosePlatform: 'Scegli una piattaforma',
  selectTargetCountry: 'Scegli il paese di destinazione',
  selectCountryTips:
    "Si prega di scegliere/compilare il proprio paese di destinazione in modo che acbuy possa distinguere se l'articolo può essere consegnato o meno.",
  pleaseSelectOrder: 'Seleziona gli ordini nella stessa valuta per la liquidazione',
  canNotStorageTip:
    'Il prodotto è in magazzino da più di 5 giorni e non può essere restituito o cambiato.',
  purchaseService: 'Servizi di acquisto',
  refundProgress: 'Elaborazione del rimborso in corso',
  returnChangeTip:
    'Nota: Se il prodotto presenta lievi problemi di qualità (tracce di colla, difetti, macchie), il venditore potrebbe non coprire le spese di reso. In questo caso, dovrai sostenere tu stesso le spese di spedizione!',
  goodNumTip:
    "Nota: Quando la quantità di acquisto dello stesso prodotto è maggiore o uguale a 10 pezzi, al fine di migliorare l'efficienza dello stoccaggio, gli ispettori di qualità effettueranno ispezioni di qualità solo sul 20% dei tuoi prodotti. Tuttavia, i colori, gli stili e le taglie di tutti i prodotti verranno comunque verificati per te. Grazie per la tua comprensione!",
  'i18n-0000001': 'Video personalizzato',
  'i18n-0000002': 'Descrizione del servizio',
  'i18n-0000003':
    'Verrà registrato un video del prodotto di 20-90 secondi (la durata può variare a seconda del prodotto), offrendo agli utenti un servizio di ispezione video personalizzato.',
  'i18n-0000004':
    "Nota : L'attivazione di prodotti elettronici o digitali potrebbe annullare il servizio post-vendita. La piattaforma non si assume alcuna responsabilità.",
  'i18n-0000005': `Al momento, le tratte nazionali sono troppo poche. Si consiglia di consultare la pagina di calcolo del trasporto o quella del carrello per calcolare il costo del trasporto prima di acquistare il prodotto, per evitare costi logistici eccessivi.`,
  'i18n-0000006': 'Percorsi di consegna verso il paese di destinazione: {lineNum}',
  buyAgain: 'Acquista di nuovo',
  remindShop: 'Ricorda la spedizione',
}
